import { ProgressIndicator, ProgressRoot } from '@nesso/ui/primitives/progress';

export function ProgressBar({ value }: { value: number }) {
    return (
        <ProgressRoot value={value}>
            <ProgressIndicator value={value} />
        </ProgressRoot>
    );
}
